<template>
    <div>
        <div>
            <form name="reqPUBForm" method="post" action="#">
                <input type="hidden" name="tr_cert" v-model="tr_cert">
                <input type="hidden" name="tr_url"  v-model="tr_url">
            </form>
        </div>
        <v-dialog/>
    </div>
</template>

<script>
import { getKmcPublEncrypt } from '@/api/step3/identificationVerfication'
export default {
    name: "CallKmcPublAuthPop",
    data() {
        return {
            tr_cert: '',
            tr_url: '',//TODO 나중에 tr_url 변경
            currentURL: '',
            reqInfo: '',
            returnURL: '',

        }

    },
    created() {
        this.getInfo();
    },
    methods: {
        /** 
         * Function    : getInfo
         * Description : KMC 정보
         **/
        getInfo() {
  
            getKmcPublEncrypt(opener.normalauthdata).then(res => {
                 if(res.data.tr_cert!==""){
                    this.tr_cert = res.data.tr_cert
                    this.tr_url = res.data.tr_url
                    this.$nextTick(() => {
                    //  document.reqPUBForm.target = 'PUBWindow'
                        document.reqPUBForm.action = 'https://www.kmcert.com/kmcis/web/kmcisReq.jsp'
                        document.reqPUBForm.submit();
                    })
                 }else{
                    alert(res.data.r_msg)
                    window.close()
                }
            }).catch(error => {
                alert(error.message)
            })
        },
    },
}
</script>

<style scoped>

</style>